import axios from "axios";
import { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";

import AuthService from "../../services/auth.service";

import Sidebar from "./sidebar";
import Physical from "./physical/physical";
import Dashboards from "./dashboard/dashboard";
import TopHeader from "./layouts/top_header/TopHeader";

import "./panel.scss";
import "react-toastify/dist/ReactToastify.css";

const APP_URL = process.env.APP_URL;

const Panel = (props) => {
  const [user, setUser] = useState(AuthService.getUser());
  const [content, setContent] = useState(null);
  const { component } = props;

  useEffect(() => {
    const interval = setInterval(() => sync(), 60000);
    return () => clearInterval(interval);
  }, []);

  function sync() {
    axios
      .get(`${APP_URL}/api/v6/users`, {
        headers: {
          Authorization: `Bearer ${AuthService.getAccessToken()}`,
          channel: sessionStorage.getItem("channel"),
        },
      })
      .then(function (response) {
        setUser(response.data.data);
        localStorage.setItem("auth", JSON.stringify(response.data.data));
        localStorage.setItem("layouts", JSON.stringify(response.data.layouts));
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  return (
    <div className="container panel-route">
      <div className="panel-container">
        <TopHeader />
        <Sidebar setContent={setContent} component={component} />

        <div className="content-container">
          {content ? (
            content
          ) : user.subscription ? (
            <Dashboards setContent={setContent} />
          ) : (
            <Physical />
          )}
        </div>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default Panel;
